import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../../core/service/common-service/common.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import {
  MatDialog,
  MatSort,
  MatPaginator,
  MatTableDataSource,
  MatTabChangeEvent,
} from "@angular/material";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { BlanketFeedbackDailogComponent } from "../../modal/blanket-feedback-dailog/blanket-feedback-dailog.component";
import { element } from 'protractor';
import { openPrsComplaintDialog } from "src/app/modal/prs-complaint-dialog/prs-complaint-dialog.component";
import { CallParams } from "src/app/model/call-params.model";
import { SaveCallRecordingParams } from "src/app/model/save-call-recording-params.model";
import { DialogService } from "src/app/dialog.service";


@Component({
  selector: "app-prs-customer360",
  templateUrl: "./prs-customer360.component.html",
  styleUrls: ["./prs-customer360.component.scss"],
})
export class PrsCustomer360Component implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild("RemarksPaginator", { static: true })
  remarksPaginator: MatPaginator;
  @ViewChild("RemarksSort", { static: true }) remarksSort: MatSort;
  @Output() close: EventEmitter<any> = new EventEmitter();
  // @ViewChild('CallLogsPaginator', { static: true }) callLogsPaginator: MatPaginator;
  @ViewChild('CallLogsSort', { static: true }) callLogsSort: MatSort;

  cus360: any;
  vehicleDetails: any = {};
  lastServiceDetails: any = {};
  serviceDetails: any = {};
  spinner: boolean;
  vinNoList: string[] = [];
  vehicleInfoList: any[] = [];
  vehicleTypeCallInfo: any;
  vehicleServiceAndStausInfo: any;
  selectedNumber: any;
  updatedNumber: any;
  contactInfoOwner: any[] = [];
  contactInfoFleet: any[] = [];
  contactInfoDriver: any[] = [];
  updatedNumberType: string;
  secondaryNo: string;
  unableEdit: any = {};
  unableCall: boolean = false;
  workShops = <any>[];
  selectedWorkShop: string;
  selectedVehicle: string;
  ownerSelected: boolean = true;
  fleetSelected: boolean = false;
  driverSelected: boolean = false;
  errorShow: any = {};
  customerID: string;
  userId: string;
  chassisNo: string;
  recentNumber: string;
  questions: any = [];
  selectedBlankRemarks: any;
  customerData: any;
  submitted: boolean = false;
  questionInfo = [];
  questionForm: FormGroup;
  questionType: any;
  blanketFeedback: any;
  jobCardNo: string;
  workshopCode: string;
  dropdownData: any = {
    "14-3": ["Comparing with other vehicle", "Sales commitment", "Customers Perception", "Service Support", "Any Other"],
    "15-1": ["Front", "Rear", "Both"],
    "15-2": ["Faster Wear", "Uneven Wear", "Tyre Burst", "Any Other"],
    "15-6": ["Tata", "Ashok Leyland", "Bharat Benz", "Mahindra", "SML"],
    "15-4": ["Apollo", "JK", "Bridgestone", "MRF"],
    "16-1": ["Noise", "Not effective", "Heating", "Juddering", "Service related", "Any Other"],
    "17-1": ["Paint Quality", "Aesthetics", "Cabin comfort", "Any Other"],
    "18-1": ["Noise", "Heating", "Steering hard", "Any Other"],
    "19-1": ["Abnormal noise ", "Vibration", "Harshness", "Breakdown related", "Service support related", "Any other"],
    "40-1": ["Availability", "Price", "Quality", "NA"],
    "40-2": ["Denied", "Information not provided", "NA"],
    "40-3": ["Adblue", "Brake", "Driveline", "Engine", "FE", "Heating", "Pickup", "Starting", "Tyre/Wheel", "Other Parts", "NA"],
    "40-4": ["Availability", "Competence", "Behavior (Technician, Manager, Mechanic, Worker)", "NA"],
    "40-5": ["High Charges", "Discount not provided", "Compensation not given", "NA"]
  };
  //call response
  disableSubmitButton: boolean = true;
  formSubmitted: boolean = false;
  talked: string = "";
  yesResponce: string = "";
  noResponce: string = "";
  nsReason: string = "";
  responseDropDownData: any;
  level1info = [];
  level1Form: FormGroup;
  level2info = [];
  level2Form: FormGroup;
  defaultVin: string;
  showNoRespError: boolean = false;
  creRemark: string;
  today: any = new Date();
  cdmTrailCheckOwner: boolean = false;
  cdmTrailCheckfleet: boolean = false;
  cdmTrailCheckdriver: boolean = false;
  secondTrailCall: boolean = false;
  diasableCreateComplain: boolean = true;
  //call log table columns
  displayedRemarksColumns: string[] = ["remark", "remarkDate", "remarkTime"];

  expandedElement: any[] = [];
  rows: any = [];

  remarksDetails: any;
  remarksCount: number = 0;
  languageList: string[] = [];
  languageMap = new Map();
  numberOfVehicle: number;
  vin: string;
  dealerCode: string;
  vinList: string[] = [];
  chassis: string;
  selectedTab: any;
  custNameForSave: any;
  userRoles: string;
  showPrs360:boolean;
  //bookingCount: number;
  followupCount: number;
  roleId: string;
  errorCheck: boolean = false;
  errorRadio: boolean = false;
  errorRadio5: boolean = false;
  countFlag: boolean;
  showRecordingDailog: boolean = false;
  vehicleMap = new Map();
  vehicleList: string[] = [];
  vehicleListCopy: string[] = [];
  vehicle: string[] = [];
  selectedVin: string;
  selectedValue: string;
  audioSource: any = {};
  showCallDailog: boolean = false;
  showPlayBtn: boolean = true;
  callLists: any;
  callCount: number = 0;
  countryCode: String;
  squareRating: any;
  blockStatus: String = 'false';

  //call log table columns
  displayedCallColumns: string[] = [
    "number",
    "callDate",
    "startTime",
    "duration",
    "recording"
  ];
  complaintId: string="";
  complaintRemarks: string="";
  callTypeCode: string="";
  userContactNo: string;

  constructor(
    private dialogService: DialogService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.unableEdit["O"] = {};
    this.unableEdit["F"] = {};
    this.unableEdit["D"] = {};
  }

  ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || null)[0];
    this.customerData = JSON.parse(localStorage.getItem("customerData") || null);
    if (
      localStorage.getItem("userId") == null ||
      localStorage.getItem("userId") == undefined
    ) {
      this.router.navigate(["login"]);
    }
    this.roleId = localStorage.getItem('roleId');
    this.countryCode = localStorage.getItem('countryCode');
    this.chassisNo = localStorage.getItem("vin");
    this.userId = localStorage.getItem("userId");
    this.customerID = localStorage.getItem("customerId");
    this.workShops = JSON.parse(localStorage.getItem("workshops")) || [];
    this.customerData = JSON.parse(localStorage.getItem("customerData")) || {};
    this.callTypeCode = this.customerData.callTypeSq;
    this.userRoles = localStorage.getItem('userRoles');
    this.userContactNo = localStorage.getItem("userContactNo");
    if(this.userRoles == 'CRE') {
      this.showPrs360 = false;
    } else if(this.userRoles == 'Call Center Agent'){
      this.showPrs360 = true;
    }
    let questionType = this.customerData.callType.split("-");
    if (questionType[0] == "PRS") {
      this.questionType = "PRS";
    } else {
      this.questionType = "149-" + this.customerData.callTypeSq;
    }
    this.selectedWorkShop = this.customerData.dealerCode || "";
    if (!this.workShops.length) {
      this.workShops.push(this.customerData.dealerCode);
    }

    if(this.roleId == "12")
    this.disableSubmitButton=false;
    this.chassis = this.customerData.vin
    this.getCustomer360();
    this.getContactdetail();
    this.getPrsFetchQuestions();
    this.getBookingFollowupCount(this.customerID, this.vin);
    if(this.roleId == '1') {
      this.getCallList();
    }
    this.fetchBlockStatus();
  }

  private show360() {
    // this.showPrs360 = true;
    // this.blockStatus = false;
    this.showRecordingDailog = false;
    //this.spinner = true;
    let callNumber = "+91" + this.selectedNumber;
    let type = (this.ownerSelected ? 'C' : (this.fleetSelected ? 'F' : 'D'));

    if(type != 'C') {
      this.blockStatus = 'false';
    }
    if(this.blockStatus == 'false') {
      this.showPrs360 = true;
      this.commonService.callCustomer(this.userId, this.customerID, callNumber, type, 'PRS').subscribe(res => {
        if (res["responseCode"] == 0) {
          this.showCallDailog = true;
          //this.spinner = false;
        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
    } else {
      this.toastr.info("Customer contact number is block. Please connect to Fleet Manager or Driver.", "Info");
    }
    if (localStorage.getItem('countryCode')=='IND91') {
      this.callingToUser();
     }else{
      localStorage.setItem("exotel_URI",'')
     }
  }

  /**
   * Name: getContactdetail
   * purpose: To get customer Contact detail
   */
  getContactdetail(): void {
    //this.spinner = true;
    this.commonService.prscontactdetail(this.customerID).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.contactInfoOwner = res["responseData"].filter(
            (contact) => contact.flag == "O"
          );
          this.contactInfoFleet = res["responseData"].filter(
            (contact) => contact.flag == "F"
          );
          this.contactInfoDriver = res["responseData"].filter(
            (contact) => contact.flag == "D"
          );
          this.selectedNumber = this.contactInfoOwner[0].contactNo;
          this.unableEdit["O"][0] = true;
          this.unableEdit["O"][1] = false;
          this.unableEdit["D"][0] = true;
          this.unableEdit["D"][1] = false;
          this.updatedNumberType = "Primary";
          this.unableCall = true;
          //this.spinner = false;
        } else {
          //this.spinner = false;
        }
      },
      (err) => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      },
      ()=>{
        this.updateActiveContactNo();
      }
    );
  }

  /**
   * Name: checkCallStatus
   * purpose: To set contect type selection
   * @param {any} type - type of number
   */
  checkCallStatus(type: any): void {
    this.onTabChange(type)
    this.selectedTab=type && type.index;
    if (type && type.index == 0) {
      this.ownerSelected = true;
      this.fleetSelected = false;
      this.driverSelected = false;
      if (this.contactInfoOwner.length) {
        this.unableCall = true;
        this.contactInfoOwner.forEach((element, i) => {
          if (this.unableEdit["O"][i] != undefined && this.unableEdit["O"][i]) {
            this.selectedNumber = element.contactNo;
          }
        });
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 1) {
      this.ownerSelected = false;
      this.fleetSelected = true;
      this.driverSelected = false;
      if (this.contactInfoFleet.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoFleet.forEach((element, i) => {
          if (this.unableEdit["F"][i] != undefined && this.unableEdit["F"][i]) {
            this.selectedNumber = element.contactNo;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoFleet[0].contactNo;
          this.unableEdit["F"][0] = true;
        }
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 2) {
      this.ownerSelected = false;
      this.fleetSelected = false;
      this.driverSelected = true;
      if (this.contactInfoDriver.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoDriver.forEach((element, i) => {
          if (this.unableEdit["D"][i] != undefined && this.unableEdit["D"][i]) {
            this.selectedNumber = element.contactNo;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoDriver[0].contactNo;
          this.unableEdit["D"][0] = true;
        }
      } else {
        this.unableCall = false;
      }
    }
    this.trailLogCheck();
  }

  getCdmData(){
    let temp:any;
    this.selectedTab=this.selectedTab?this.selectedTab:0;

    let ab={id: 2, name: "SHAH SAMIRKUMAR KANAIYALAL", contactNo: "111111111", regNumber: null, flag: "O"}
    // this.contactInfoOwner.push(ab);
    let data={
      "customerId": this.customerID,
      "vin": "",
      "phoneNo": "",
      "startDate": "",
      "endDate": "",
      "date": "",
      "customerName": "",
      "type": "T",
      "flag":this.selectedTab==0?'C':this.selectedTab==1?'F':this.selectedTab==2?'D':'C'
       };
    this.commonService.fetchCdmData(data).subscribe((resp)=>{
      if(resp['responseCode']==0){
        temp=resp["responseData"].filter(contact => contact.contactNo = contact.phoneNo);
        temp.forEach((trail)=>{
          if(this.selectedTab==0){
          this.contactInfoOwner.push(trail)
          this.cdmTrailCheckOwner=true
          }else if(this.selectedTab==1){
            this.contactInfoFleet.push(trail)
            this.cdmTrailCheckfleet=true
          }else if(this.selectedTab==2){
            this.contactInfoDriver.push(trail)
            this.cdmTrailCheckdriver=true
          }
        })
        this.trailLogCheck();
      }else{
        this.toastr.error(resp['message'], "Error");
      }

    }, error => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
      });
    // this.contactInfoOwner.push(temp[0]);

  }

  trailLogCheck(){
    if(this.selectedTab==0){
      this.secondTrailCall=this.cdmTrailCheckOwner
      // return this.cdmTrailCheckOwner
    }else if (this.selectedTab==1){
      this.secondTrailCall=this.cdmTrailCheckfleet
      // return this.cdmTrailCheckfleet
    }else if(this.selectedTab==2){
      this.secondTrailCall=this.cdmTrailCheckdriver
      // return this.cdmTrailCheckdriver
    }else{
      this.secondTrailCall=false
    }
  }

  /**
   * Name: updateNumber
   * @param {boolean} addNumber - type of number
   * purpose: To set customer number
   */
  updateNumber(addNumber: boolean): void {
    if (
      (this.updatedNumber && this.updatedNumber.length == 10) ||
      (addNumber && this.secondaryNo && this.secondaryNo.length == 10)
    ) {
      this.spinner = true;
      let oldNumber = this.selectedNumber;
      let newNumber = this.updatedNumber;
      if (addNumber) {
        oldNumber = this.secondaryNo;
        newNumber = this.secondaryNo;
        this.updatedNumberType = "Secondary";
      }
      this.commonService
        .updatePRSNumber(
          newNumber,
          oldNumber,
          this.updatedNumberType,
          this.customerID,
          this.userId
        )
        .subscribe(
          (res) => {
            if (res["responseCode"] == 0) {
              this.spinner = false;
              this.selectedNumber = this.updatedNumber;
              this.toastr.success("New number is saved.", "Success");
              this.getContactdetail();
            } else {
              this.spinner = false;
              this.toastr.error(res["message"], "Error");
            }
          },
          (err) => {
            this.spinner = false;
            this.toastr.error(
              "Something went wrong, Please try again.",
              "Error"
            );
          }
        );
    }
  }

  /**
   * Name: onNumberChange
   * purpose: To get new selected number
   */
  onNumberChange(
    number: any,
    editNumber: boolean,
    index: any,
    type: string
  ): void {
    if (type == "D" && editNumber && number.currentTarget.value.length == 10) {
      this.updatedNumber = number.currentTarget.value;
      this.updatedNumberType = "D";
      this.errorShow[index] = false;
    } else if (type == "F" && editNumber && number.currentTarget.value.length == 10) {
      this.updatedNumber = number.currentTarget.value;
      this.updatedNumberType = "F";
      this.errorShow[index] = false;
    } else if (editNumber && number.currentTarget.value.length == 10) {
      this.updatedNumber = number.currentTarget.value;
      this.updatedNumberType = index == 0 ? "Y" : "N";
      this.errorShow[index] = false;
    } else if (editNumber && number.currentTarget.value.length !== 10) {
      this.errorShow[index] = true;
    } else {
      this.selectedNumber = number.value;
      this.updatedNumber = number.value;
      this.updatedNumberType = index == 0 ? "Y" : "N";
      if (type == "O") {
        this.contactInfoOwner.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == "F") {
        this.contactInfoFleet.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == "D") {
        this.contactInfoDriver.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      }
    }
  }

  /**
   * Name: sendInfoMsg
   * purpose: To send workshop addess SMS
   */
  sendInfoMsg(): void {
    this.spinner = true;
    this.commonService
      .prsSendinfo(this.customerData.customerName, this.selectedNumber)
      .subscribe(
        (res) => {
          if (res["responseCode"] == 0) {
            this.spinner = false;
          } else {
            this.spinner = false;
            this.toastr.error(res["message"], "Error");
          }
        },
        (err) => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        }
      );
  }

  /**
   * Name: subTabDefault
   * purpose: To set vehicle details as selected
   */
  subTabDefault(selectedVehicle: string): void {
    // this.vehicleDetails = this.cus360["VECHILE_INFO"].filter((vehicle) => vehicle.chassisNo == selectedVehicle)[0];
    // this.workshopCode = this.vehicleDetails.dealerCode;
    //localStorage.setItem("chassisNo", this.vehicleDetails.chassisNo);
    //this.chassisNo = this.vehicleDetails.chassisNo;
    //change the sale date format
    // this.vehicleDetails.saleDate = this.datePipe.transform(
    //   this.vehicleDetails.saleDate,
    //   "dd-MM-yyyy"
    // );

    let selectedVehicleCategory;
    //let vinremark;
    if(this.questionType == 'PRS'){
      //selectedVehicleCategory = selectedVehicle+" - "+this.workshopCode;
      selectedVehicleCategory = selectedVehicle;
      let vin = selectedVehicleCategory.split(' - ')[0];
      this.selectedVin = vin;
      //vinremark = vin;
      this.workshopCode = selectedVehicleCategory.split(' - ')[1];
      this.vehicleDetails = this.cus360["VECHILE_INFO"].filter((vehicle) => ((vehicle.chassisNo == vin) && (vehicle.dealerCode == this.workshopCode)))[0];
    } else {
      this.vehicleDetails = this.cus360["VECHILE_INFO"].filter((vehicle) => vehicle.chassisNo == selectedVehicle.split(' - ')[0])[0];
      this.workshopCode = this.vehicleDetails.dealerCode;
      //selectedVehicleCategory = selectedVehicle;
      selectedVehicleCategory = selectedVehicle.split(' - ')[0];
     // vinremark = selectedVehicle.split(' - ')[0];
      this.defaultVin = selectedVehicle;
    }

    this.getLastServiceRemark(selectedVehicle);
  }

  getLastServiceRemark(selectedVehicle: string): void {
    this.spinner = true;
    let vin = selectedVehicle.split(' - ')[0];
    let workshopcode = selectedVehicle.split(' - ')[1];
    this.commonService.getLastServiceRemark(this.customerData.customerId, vin, workshopcode, this.customerData.callTypeSq, this.userId, this.roleId)
    .subscribe((res) => {
      if (res["responseCode"] == 0) {
        let response = res["responseData"];

        let vinSelect = '';
        if(this.questionType == 'PRS') {
          vinSelect = selectedVehicle;
        } else {
          vinSelect = selectedVehicle.split(' - ')[0];
        }
        if (response["LAST_SERVICE_INFO"] && Object.keys(response["LAST_SERVICE_INFO"]).length) {
          this.lastServiceDetails = response["LAST_SERVICE_INFO"][vinSelect];
          this.jobCardNo = this.lastServiceDetails.jobCardNo;
          localStorage.setItem("milage", this.lastServiceDetails.milage);
        } else {
          this.lastServiceDetails = {};
        }

        if (response["Remark_Info"] && Object.keys(response["Remark_Info"]).length) {
          let remarks = response["Remark_Info"][selectedVehicle.split(' - ')[0]];
          remarks.forEach((element) => {
            let date = element.remarkDate + " " + element.remarkTime + " GMT+0000";
            let d = new Date(date);
            element.remarkTime = d;
            element.remarkDate = this.datePipe.transform(d, "dd-MM-yyyy");
          });
          this.remarksDetails = new MatTableDataSource(remarks);
          this.sort.direction = "";
          this.remarksDetails.sort = this.remarksSort;
          this.remarksDetails.paginator = this.remarksPaginator;
          this.remarksCount = remarks.length;
        } else {
          this.remarksDetails = [];
        }
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res["message"], "Error");
      }
    })
  }

  /**
   * Name: getCustomer360
   * purpose: To get customer data
   */
  getCustomer360(): void {
    this.spinner = true;
    this.vehicleList = [];
    this.vin = this.questionType == "PRS" ? this.chassis : "";
    this.dealerCode = this.customerData.dealerCode || "";
    this.commonService
      .getprscustomerdata(this.customerData.customerId, this.vin, this.dealerCode, this.customerData.callTypeSq, this.userId, this.roleId)
      .subscribe(
        (res) => {
          if (res["responseCode"] == 0) {
            this.cus360 = res["responseData"];
            if (
              this.cus360["VECHILE_INFO"] &&
              this.cus360["VECHILE_INFO"].length &&
              this.cus360["VECHILE_INFO"][0].chassisNo
            ) {
              //this.selectedVehicle = this.cus360["VECHILE_INFO"][0].chassisNo;
              if(this.questionType == 'PRS') {
                let chassiItem = this.cus360["VECHILE_INFO"].find((ele) => {return ele.chassisNo == this.chassis});
                let index = this.cus360["VECHILE_INFO"].findIndex((ele) => {return ele.chassisNo == this.chassis});
                if(index != -1) {
                  this.cus360["VECHILE_INFO"].splice(index, 1);
                  this.cus360["VECHILE_INFO"].unshift(chassiItem);
                }

                this.selectedVehicle = this.cus360["VECHILE_INFO"][0].chassisNo + " - " + this.cus360["VECHILE_INFO"][0].soldBy.split(' - ')[0];
                this.defaultVin = this.cus360["VECHILE_INFO"][0].chassisNo;
                this.selectedVin = this.defaultVin;
              } else {
                this.selectedVehicle = this.cus360["VECHILE_INFO"][0].chassisNo + " - " + this.cus360["VECHILE_INFO"][0].soldBy.split(' - ')[0];;
                this.defaultVin = this.selectedVehicle.split(' - ')[0];
              }
              this.vinList = this.cus360.VECHILE_INFO;
              this.numberOfVehicle = this.cus360["VECHILE_INFO"].length;
              this.cus360["VECHILE_INFO"].forEach((element) => {
                this.vinNoList.push(element.chassisNo);
                this.vehicleInfoList.push(element);
                let seller = element.soldBy;
                if(seller) {
                  element.soldBy = seller.split(' - ')[1];
                  element.dealerCode = seller.split(' - ')[0];
                  //this.vehicleMap.set(element.chassisNo, element.chassisNo+" - "+element.dealerCode);
                  this.vehicleList.push(element.chassisNo+" - "+element.dealerCode);
                }
              });
              this.vehicleListCopy = this.vehicleList;
              this.subTabDefault(this.vehicleList[0]);
            } else {
              this.vehicleDetails = {};
            }
            this.spinner = false;
          } else {
            this.spinner = false;
            this.toastr.error(res["message"], "Error");
          }
        },
        (err) => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        }
      );
  }

  /**
   * Name: getPrsFetchQuestions
   * purpose: To get Prs Questions
   */
  getPrsFetchQuestions(): void {
    //this.spinner = true;
    this.commonService.getPrsFetchQuestions(this.questionType, this.roleId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.questions = [];
          let groups = [];
          res["responseData"].forEach((element) => {
            let questionGroup = [];
            let groupexist = groups.filter(
              (group) => group == element.parentId
            );
            if (Number(element.parentId) > 0 && groupexist.length == 0) {
              questionGroup = res["responseData"].filter(
                (question) => question.parentId == element.parentId
              );
              this.questions.push(questionGroup);
              groups.push(element.parentId);
            } else if (groupexist.length == 0) {
              this.questions.push(element);
            }
          });
          this.createQuestionForm(this.questions);
          //this.spinner = false;
        } else {
          //this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (err) => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: createQuestionForm
   * purpose: To create question form
   */
  createQuestionForm(data: any) {
    this.submitted = false;
    const formDataObj = {};
    let questionIdAdded = [];

    for (const prop of data) {
      if (!prop.length) {
        let questionExist;
        if (prop.radioButtonType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "radio"] = new FormControl("");
          this.questionInfo.push({
            label: prop.questionId + "radio",
            type: "RadioButton",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.ratingType == "Yes") {
          //remarks rating
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "rate"] = new FormControl("");
          this.questionInfo.push({
            label: prop.questionId + "rate",
            type: "Rate",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.remarksType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "text"] = new FormControl("");
          this.questionInfo.push({
            label: prop.questionId + "text",
            type: "Text",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
          });
          questionIdAdded.push(prop.questionId);
        }
      } else {
        let subQuestionInfo = [];
        prop.forEach((questionData: any, index: any) => {
          let questionExist;
          if (
            questionData.questionId == "14-3" ||
            questionData.questionId == "15-1" ||
            questionData.questionId == "15-2" ||
            questionData.questionId == "15-4" ||
            questionData.questionId == "15-6" ||
            questionData.questionId == "16-1" ||
            questionData.questionId == "17-1" ||
            questionData.questionId == "18-1" ||
            questionData.questionId == "19-1" ||
            questionData.questionId == "40-1" ||
            questionData.questionId == "40-2" ||
            questionData.questionId == "40-3" ||
            questionData.questionId == "40-4" ||
            questionData.questionId == "40-5"
          ) {
            questionExist = questionIdAdded.filter(
              (group) => group == questionData.questionId
            );
            formDataObj[questionData.questionId + "dropdown"] = new FormControl(
              ""
            );
            subQuestionInfo.push({
              label: questionData.questionId + "dropdown",
              type: "Dropdown",
              desc: questionData.questionDesc,
              id: questionData.questionSequence,
              questionId: questionData.questionId,
              showDesc: questionExist.length ? false : true,
              subQuestion: true,
              parentId: questionData.parentId,
              data: this.dropdownData[questionData.questionId],
            });
            questionIdAdded.push(questionData.questionId);
          } else {
            if (questionData.radioButtonType == "Yes") {
              questionExist = questionIdAdded.filter(
                (group) => group == questionData.questionId
              );
              formDataObj[questionData.questionId + "radio"] = new FormControl(
                ""
              );
              subQuestionInfo.push({
                label: questionData.questionId + "radio",
                type: "RadioButton",
                desc: questionData.questionDesc,
                id: questionData.questionSequence,
                questionId: questionData.questionId,
                parentId: questionData.parentId,
                showDesc: questionExist.length ? false : true,
                subQuestion: index == 0 ? false : true,
              });
              questionIdAdded.push(questionData.questionId);
            }
            if (questionData.ratingType == "Yes") {
              //remarks rating
              questionExist = questionIdAdded.filter(
                (group) => group == questionData.questionId
              );
              formDataObj[questionData.questionId + "rate"] = new FormControl(
                ""
              );
              subQuestionInfo.push({
                label: questionData.questionId + "rate",
                type: "Rate",
                desc: questionData.questionDesc,
                id: questionData.questionSequence,
                questionId: questionData.questionId,
                parentId: questionData.parentId,
                showDesc: questionExist.length ? false : true,
                subQuestion: index == 0 ? false : true,
              });
              questionIdAdded.push(questionData.questionId);
            }
            if (questionData.remarksType == "Yes") {
              questionExist = questionIdAdded.filter(
                (group) => group == questionData.questionId
              );
              formDataObj[questionData.questionId + "text"] = new FormControl(
                ""
              );
              subQuestionInfo.push({
                label: questionData.questionId + "text",
                type: "Text",
                desc: questionData.questionDesc,
                id: questionData.questionSequence,
                questionId: questionData.questionId,
                parentId: questionData.parentId,
                showDesc: questionExist.length ? false : true,
                subQuestion: index == 0 ? false : true,
              });
              questionIdAdded.push(questionData.questionId);
            }
          }
        });

        this.questionInfo.push(subQuestionInfo);
      }
    }
    this.questionForm = new FormGroup(formDataObj);
  }

  checkQuestionValidation(): boolean {
    let valid = true;
    // this.errorCheck = false;
    // this.errorCheck15 = false;
    if (this.questionForm !== undefined) {
      if (
        this.questionForm.value["14rate"] &&
        this.questionForm.value["14rate"] != null &&
        this.questionForm.value["14rate"] <= 3
      ) {
        if (
          !this.questionForm.value["14-1text"] ||
          !this.questionForm.value["14-2text"] ||
          !this.questionForm.value["14-3dropdown"] ||
          !this.questionForm.value["14-4text"]
        ) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (
        this.questionForm.value["15rate"] &&
        this.questionForm.value["15rate"] != null &&
        this.questionForm.value["15rate"] <= 3
      ) {
        if (
          !this.questionForm.value["15-1dropdown"] ||
          !this.questionForm.value["15-2dropdown"] ||
          !this.questionForm.value["15-3radio"] ||
          !this.questionForm.value["15-5text"] ||
          !this.questionForm.value["15-6dropdown"]
        ) {
          valid = false;
        }
        if(this.questionForm.value["15-3radio"] == 'No' && this.questionForm.value["15-4dropdown"] == ''){
          valid = false;
        }
      }
      if (
        this.questionForm.value["16rate"] &&
        this.questionForm.value["16rate"] != null &&
        this.questionForm.value["16rate"] <= 3
      ) {
        if (!this.questionForm.value["16-1dropdown"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (
        this.questionForm.value["17rate"] &&
        this.questionForm.value["17rate"] != null &&
        this.questionForm.value["17rate"] <= 3
      ) {
        if (!this.questionForm.value["17-1dropdown"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (
        this.questionForm.value["18rate"] &&
        this.questionForm.value["18rate"] != null &&
        this.questionForm.value["18rate"] <= 3
      ) {
        if (!this.questionForm.value["18-1dropdown"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (
        this.questionForm.value["19rate"] &&
        this.questionForm.value["19rate"] != null &&
        this.questionForm.value["19rate"] <= 3
      ) {
        if (!this.questionForm.value["19-1dropdown"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if(
        this.questionForm.value["33radio"] == 'No'
      ) {
        if(this.questionForm.value["33-1radio"] == '') {
          this.errorRadio = true;
          valid = false;
        }
      }

      if (this.questionForm.value['31radio'] == '' || this.questionForm.value['13radio'] == '' || this.questionForm.value['20radio'] == '' || this.questionForm.value['27radio'] == '' ){
        //this.errorRadio = true;
        valid = false;
      }

      if (
        this.questionForm.value["35radio"] == 'Yes'
      ) {
        if(this.questionForm.value["36radio"] == '') {
          this.errorRadio5 = true;
          valid = false;
        }
      }
      if(this.questionForm.value["37text"] == '') {
        this.errorCheck = true;
        valid = false;
      }
      if (this.questionForm.value["48text"] == '') {
        this.errorCheck = true;
        valid = false;
      }
      if(
        this.questionForm.value["39radio"] == 'No'
      ) {
        if(this.questionForm.value["39text"] == '') {
          //this.errorRadio5 = true;
          valid = false;
        }
      }
      // for making leading reason mandatory in PRS for blanket feedback
      if (this.blanketFeedback == 'S' || this.blanketFeedback == 'D') {
        if (
          this.questionForm.value["40-1dropdown"] == '' ||
          this.questionForm.value["40-2dropdown"] == '' ||
          this.questionForm.value["40-3dropdown"] == '' ||
          this.questionForm.value["40-4dropdown"] == '' ||
          this.questionForm.value["40-5dropdown"] == ''
        ) {
          valid = false;
        }
      }
      if (this.questionForm.value["56-2rate"] && this.questionForm.value["56-2rate"] != null && this.questionForm.value["56-2rate"] <= 3) {
        if (!this.questionForm.value["56-2text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["57-2rate"] && this.questionForm.value["57-2rate"] != null && this.questionForm.value["57-2rate"] <= 3) {
        if (!this.questionForm.value["57-2text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["58-2rate"] && this.questionForm.value["58-2rate"] != null && this.questionForm.value["58-2rate"] <= 3) {
        if (!this.questionForm.value["58-2text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["59rate"] && this.questionForm.value["59rate"] != null && this.questionForm.value["59rate"] <= 3) {
        if (!this.questionForm.value["59text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["61rate"] && this.questionForm.value["61rate"] != null && this.questionForm.value["61rate"] <= 3) {
        if (!this.questionForm.value["61text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["62rate"] && this.questionForm.value["62rate"] != null && this.questionForm.value["62rate"] <= 3) {
        if (!this.questionForm.value["62text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["64rate"] && this.questionForm.value["64rate"] != null && this.questionForm.value["64rate"] <= 3) {
        if (!this.questionForm.value["64text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["65rate"] && this.questionForm.value["65rate"] != null && this.questionForm.value["65rate"] <= 3) {
        if (!this.questionForm.value["65text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["66rate"] && this.questionForm.value["66rate"] != null && this.questionForm.value["66rate"] <= 3) {
        if (!this.questionForm.value["66text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["67rate"] && this.questionForm.value["67rate"] != null && this.questionForm.value["67rate"] <= 3) {
        if (!this.questionForm.value["67text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["68rate"] && this.questionForm.value["68rate"] != null && this.questionForm.value["68rate"] <= 3) {
        if (!this.questionForm.value["68text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["69rate"] && this.questionForm.value["69rate"] != null && this.questionForm.value["69rate"] <= 3) {
        if (!this.questionForm.value["69text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["70rate"] && this.questionForm.value["70rate"] != null && this.questionForm.value["70rate"] <= 3) {
        if (!this.questionForm.value["70text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["73rate"] && this.questionForm.value["73rate"] != null && this.questionForm.value["73rate"] <= 3) {
        if (!this.questionForm.value["73text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["74rate"] && this.questionForm.value["74rate"] != null && this.questionForm.value["74rate"] <= 3) {
        if (!this.questionForm.value["74text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["75rate"] && this.questionForm.value["75rate"] != null && this.questionForm.value["75rate"] <= 3) {
        if (!this.questionForm.value["75text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["76rate"] && this.questionForm.value["76rate"] != null && this.questionForm.value["76rate"] <= 3) {
        if (!this.questionForm.value["76text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["77rate"] && this.questionForm.value["77rate"] != null && this.questionForm.value["77rate"] <= 3) {
        if (!this.questionForm.value["77text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["78rate"] && this.questionForm.value["78rate"] != null && this.questionForm.value["78rate"] <= 3) {
        if (!this.questionForm.value["78text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["80rate"] && this.questionForm.value["80rate"] != null && this.questionForm.value["80rate"] <= 3) {
        if (!this.questionForm.value["80text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["81rate"] && this.questionForm.value["81rate"] != null && this.questionForm.value["81rate"] <= 3) {
        if (!this.questionForm.value["81text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["82rate"] && this.questionForm.value["82rate"] != null && this.questionForm.value["82rate"] <= 3) {
        if (!this.questionForm.value["82text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["83rate"] && this.questionForm.value["83rate"] != null && this.questionForm.value["83rate"] <= 3) {
        if (!this.questionForm.value["83text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["84rate"] && this.questionForm.value["84rate"] != null && this.questionForm.value["84rate"] <= 3) {
        if (!this.questionForm.value["84text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["85rate"] && this.questionForm.value["85rate"] != null && this.questionForm.value["85rate"] <= 3) {
        if (!this.questionForm.value["85text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
      if (this.questionForm.value["87-2rate"] && this.questionForm.value["87-2rate"] != null && this.questionForm.value["87-2rate"] <= 3) {
        if (!this.questionForm.value["87-2text"]) {
          valid = false;
          //this.errorCheck = true;
        }
      }
    }
    this.formSubmitted = valid;
    return valid;
  }

  getFeedbackValue(): any {
    let idFeedback = "";
    let formValue = this.questionForm.value;
    this.questions.forEach((element, index) => {
      if (element.length) {
        element.forEach((subElement, subindex) => {
          if (
            subElement.questionId == "14-3" || subElement.questionId == "15-1" ||
            subElement.questionId == "15-2" || subElement.questionId == "15-6" ||
            subElement.questionId == "16-1" || subElement.questionId == "17-1" ||
            subElement.questionId == "18-1" || subElement.questionId == "15-4" ||
            subElement.questionId == "40-1" || subElement.questionId == "40-2" ||
            subElement.questionId == "40-3" || subElement.questionId == "40-4" ||
            subElement.questionId == "40-5" ||
            (subElement.questionId == "19-1" &&
            formValue[subElement.questionId + "dropdown"] &&
            formValue[subElement.questionId + "dropdown"] != null &&
            formValue[subElement.questionId + "dropdown"] != "")
          ) {
            let feedback1 = subElement.questionId + "#" + formValue[subElement.questionId + "dropdown"] + "#" + "";
            idFeedback = idFeedback == "" ? feedback1 : idFeedback + ";" + feedback1;
          } else if(subElement.questionId == "14-1" || subElement.questionId == "14-2"
          || subElement.questionId == "14-4" || subElement.questionId == "15-4"
          || subElement.questionId == "15-5") {
            let feedback = "";
            if ( subElement.ratingType == "No" && formValue[subElement.questionId + "text"]) {
              feedback = subElement.questionId + "#" + formValue[subElement.questionId + "text"] + "#" + "";
            } else {
              feedback = subElement.questionId + "#" + "" + "#" + "";
            }
            idFeedback = idFeedback == "" ? feedback : idFeedback + ";" + feedback;
          } else {
            let feedback = "";
            if (subElement.radioButtonType == "Yes" && formValue[subElement.questionId + "radio"]) {
              feedback = feedback + "#" + formValue[subElement.questionId + "radio"];
            } else if(subElement.radioButtonType == "Yes"){
              feedback = feedback + "#"+ "";
            }
            if (subElement.ratingType == "Yes" && formValue[subElement.questionId + "rate"]) {
              feedback = feedback + "#" + formValue[subElement.questionId + "rate"];
            } else if(subElement.ratingType == "Yes"){
              feedback = feedback + "#"+ "";
            }
            if ( subElement.remarksType == "Yes" && formValue[subElement.questionId + "text"]) {
              feedback = feedback + "#" + formValue[subElement.questionId + "text"];
            } else {
              feedback = feedback + "#" + "";
            }
            feedback = feedback != "" ? subElement.questionId + feedback : feedback;
            if (feedback != "") {
              if (index == 0 && subindex == 0) {
                idFeedback = feedback;
              } else {
                idFeedback = idFeedback == "" ? feedback : idFeedback + ";" + feedback;
              }
            }
          }
        });
      } else {
        let feedback = "";
        if ( element.radioButtonType == "Yes" && formValue[element.questionId + "radio"]) {
          feedback = feedback + "#" + formValue[element.questionId + "radio"];
        } else if(element.radioButtonType == "Yes"){
          feedback = feedback + "#"+ "";
        }
        if ( element.ratingType == "Yes" && formValue[element.questionId + "rate"]) {
          feedback = feedback + "#" + formValue[element.questionId + "rate"];
        } else if(element.ratingType == "Yes"){
          feedback = feedback + "#"+ "";
        }
        if ( element.remarksType == "Yes" && formValue[element.questionId + "text"]) {
          feedback = feedback + "#" + formValue[element.questionId + "text"];
        } else {
          feedback = feedback + "#" + "";
        }
        feedback = feedback != "" ? element.questionId + feedback : feedback;
        if (feedback != "") {
          if (index == 0) {
            idFeedback = feedback;
          } else {
            idFeedback = idFeedback == "" ? feedback : idFeedback + ";" + feedback;
          }
        }
      }
    });
    return idFeedback;
  }

  getCustomerName(type){
    if(type=='C'){
      this.contactInfoOwner.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }else if(type=='F'){
      this.contactInfoFleet.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }
    else if(type=='D'){
      this.contactInfoDriver.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }
    else{
      this.custNameForSave= this.customerData.customerName
    }
  }

  saveResponseData() {
    this.formSubmitted = true;
    if (this.checkQuestionValidation()) {
      let idFeedback = "";
      let vin = "";
      if (!this.blanketFeedback) {
        idFeedback = this.getFeedbackValue();
      }
      if (this.blanketFeedback == 'S' || this.blanketFeedback == 'D') {
        idFeedback = this.getFeedbackValue();
      }
      if(this.jobCardNo == undefined){
        this.jobCardNo = "";
      }
      if(this.questionType != 'PRS') {
        vin = this.selectedVehicle.split(' - ')[0];
      } else {
        vin = this.selectedVin;
      }
      let type = this.ownerSelected ? 'C' : (this.fleetSelected ? 'F' : 'D')
      this.getCustomerName(type);
      let request = {
        blanketFeedback: this.blanketFeedback || "N",
        callTypeInd: this.questionType || "",
        customerId: this.customerData.customerId || "",
        idFeedback: idFeedback || "",
        jobCardNo: this.jobCardNo,
        userId: this.userId || "",
        vin: vin,
        workshopCode: this.workshopCode || "",
        customerType: type,
        phoneNo: this.selectedNumber?this.selectedNumber:'',
        customerName: this.custNameForSave?this.custNameForSave:'',
        roleId: this.roleId,
        callTypeCode: this.customerData.callTypeCode,
        callTypeSeq: this.customerData.callTypeSq,
        dtsCreation: new Date(),
        remark: this.creRemark || "",
      };

      if (this.blanketFeedback == "S" || this.blanketFeedback == "D") {
        const dialogRef = this.dialog.open(BlanketFeedbackDailogComponent, {
          width: '550px',
          data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.saveResponse(request);
          } else {
            this.formSubmitted = false;
            this.spinner = false;
          }
        });
      } else {
        this.saveResponse(request);
      }

    }
  }

  saveResponse(requestData: any): void {
    //this.commonService.prsCustomerResponse = '';
    if (this.customerData.callTypeSq == '3' && this.roleId == '12') {

          this.commonService.prsFeedbackCheck(requestData).subscribe((res) => {

            if (res["responseCode"] == 0) {

              this.spinner = false;

              this.toastr.info(res["message"], "Success");
            } else {
              this.spinner = false;
              this.toastr.error(res["message"], "Error");
            }
          }, (error) => {
            this.toastr.error(error, "Error");
            this.spinner = false;
          })
        }
        this.commonService.prsSaveVinFeedback(requestData,this.complaintId,this.complaintRemarks).subscribe(
          (res) => {
            if (res["responseCode"] == 0) {
              this.spinner = false;
              this.toastr.info(res["message"], "Success");
              this.commonService.prsCustomerResponse = requestData;
              this.clear();
              this.formSubmitted = false;
              if(!((this.cus360.VECHILE_INFO.length - 1) > 0)) {
                this.router.navigate(["prs-calling"]);
              } else {
                this.chassis = this.cus360["VECHILE_INFO"].filter((vehicle) => vehicle.chassisNo != this.selectedVin)[0].chassisNo;
                this.getCustomer360();
              }
            } else {
              this.formSubmitted = false;
              this.spinner = false;
              this.toastr.error(res["message"], "Error");
            }
          },
          (error) => {
            this.formSubmitted = false;
            this.toastr.error(error, "Error");
            this.spinner = false;
          });
  }

  /**
   * Name: hasQuesDataError
   * purpose: To check if customer form has any error
   * @param {any} control - form control
   * @return {boolean} flag to determine if form is valid.
   */
  hasQuesDataError(control: any, form: any): boolean {
    let controler = form.controls[control];
    return (
      controler &&
      (this.formSubmitted || controler.touched || controler.dirty) &&
      !controler.valid
    );
  }

  clear() {
    this.questionForm = undefined;
    this.questionInfo = [];
    this.createQuestionForm(this.questions);
    this.blanketFeedback = "";
    this.formSubmitted = false;
    this.diasableCreateComplain=true;
  }

  /**
   * Name: prsCustomeResponse
   * purpose: To get Prs Custome Response
   * @param {string} status - call status
   */
  prsCustomeResponse(status: string): void {
    this.submitted = false;
    if ("101" == status) {
      this.talked = "101";
      this.noResponce = "";
      const self = this;
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      let callType = "4";
      this.commonService.prsCustomeResponse(callType).subscribe(
        (res) => {
          if (res["responseCode"] == 0) {
            let data = res["responseData"];
            self.responseDropDownData = data;
            this.createLevel1Form(data["Level1"]);
            this.getLanguage();
          } else {
            this.spinner = false;
            this.toastr.error(res["message"], "Error");
          }
        },
        (error) => {
          this.toastr.error(error, "Error");
          this.spinner = false;
        }
      );
    } else {
      this.talked = "102";
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.yesResponce = "";
      this.nsReason = "";
    }
  }

  /**
   * Name: createLevel1Form
   * purpose: To create Level1 Form
   * @param {any} data - form data
   */
  createLevel1Form(data: any): void {
    this.submitted = false;
    this.countFlag = false;
    const formDataObj = {};
    for (const prop of data) {
      formDataObj[prop.label] = new FormControl("", [Validators.required]);
      if (prop.dataType == "Dropdown") {
        this.countFlag=true
        var dropDownData = [];
        prop.data.forEach((element) => {
          if ((element.key == "202" && this.followupCount <=9 ) || element.key == "203" || element.key == "210" || element.key == "211" || element.key == "212") {
            dropDownData.push({ value: element.key, viewValue: element.value });
          }
        });
      }
      this.level1info.push({
        label: prop.label,
        type: prop.dataType,
        data: prop.dataType === "Dropdown" ? dropDownData : prop.data,
      });
    }
    this.level1Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel2Form
   * purpose: To create Level2 Form
   * @param {any} data - form data
   */
  createLevel2Form(data: any): void {
    this.submitted = false;
    this.level2Form = undefined;
    this.level2info = [];
    const formDataObj = {};
    let selection = this.level1Form.controls["Select Reason"].value;
    if (data[selection] && data[selection].length) {
      for (const prop of data[selection]) {
        if (prop.dataType == "Dropdown") {
          if (selection == "211") {
            formDataObj[prop.label] = new FormControl("", Validators.required);
            var dropDownData = [];
            this.languageList.forEach((element) => {
              dropDownData.push({ value: this.languageMap.get(element), viewValue: element});
            });
          } else {
            formDataObj[prop.label] = new FormControl("", Validators.required);
            var dropDownData = [];
            prop.data.forEach((element) => {
              dropDownData.push({ value: element.key, viewValue: element.value });
            });
          }
        } else if (prop.dataType == "Date") {
          formDataObj[prop.data[0].key] = new FormControl("", [
            Validators.required,
          ]);
        } else if (prop.dataType == "Number") {
          formDataObj[prop.data[0].key] = new FormControl("", [
            Validators.minLength(10),
            Validators.maxLength(10),
          ]);
        } else {
          formDataObj[prop.data[0].key] = new FormControl("");
        }
        this.level2info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.dataType === "Dropdown" ? dropDownData : prop.data,
        });
      }
    }

    this.level2Form = new FormGroup(formDataObj);
  }

  /**
   * Name: hasDataError
   * purpose: To check if customer form has any error
   * @param {any} control - form control
   * @return {boolean} flag to determine if form is valid.
   */
  hasDataError(control: any, form: any): boolean {
    let controler = form.controls[control];
    return (
      controler &&
      (this.submitted || controler.touched || controler.dirty) &&
      !controler.valid
    );
  }

  checkFormValidation(): boolean {
    let valid = true;
    if (this.talked == "102" && this.noResponce == "") {
      valid = false;
    } else if (this.level1Form !== undefined && !this.level1Form.valid) {
      valid = false;
    } else if (this.level2Form !== undefined && !this.level2Form.valid) {
      valid = false;
    }
    this.submitted = valid;
    return valid;
  }

  /**
   * Name: createLevelWiseData
   * purpose: To create LevelWise Data
   */
  createLevelWiseData() {
    var levelResponseData = {};

    if (this.level1Form !== undefined) {
      let obj = {};
      Object.keys(this.level1Form.value).filter((data) => {
        obj[this.level1Form.value[data]] = this.level1Form.value[data];
      });
      levelResponseData["Level1"] = obj;
    } else {
      levelResponseData["Level1"] = null;
    }

    if (this.level2Form !== undefined) {
      if (this.level2Form.value[304] != null) {
        this.level2Form.value[303] = this.datePipe.transform(
          this.level2Form.value[304],
          "yyyy-MM-ddTHH:mm:ssZ","+0000"
        );
        this.level2Form.value[304] = this.datePipe.transform(
          this.level2Form.value[304],
          "yyyy-MM-dd","+0000"
        );
      }
      levelResponseData["Level2"] = this.level2Form.value;
    } else {
      levelResponseData["Level2"] = null;
    }
    return levelResponseData;
  }

  getBookingFollowupCount(customerId: string, vin: string){
    this.commonService.getBookingFollowupCount(customerId, vin, 'prs')
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          // this.bookingCount = res['responseData'].bookingCount;
          this.followupCount = res['responseData'].followUpCount;

        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });

  }

  /**
   * Name: saveCallResponse
   * purpose: To save Dial Data
   */
  saveCallResponse() {
    //this.commonService.customerResponse = '';
    this.submitted = true;
    if (this.checkFormValidation()) {
      this.showNoRespError = false;
      var levelData = this.createLevelWiseData();
      this.spinner = true;
      let serviceDueDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      let startTime = new Date();
      let endTime = new Date();
      let vin = "";
      if(this.questionType != 'PRS') {
        vin = this.selectedVehicle.split(' - ')[0];
      } else {
        vin = this.selectedVin;
      }
      endTime.setSeconds(endTime.getSeconds() + 5);
      let type=this.ownerSelected ? 'C' : (this.fleetSelected ? 'F' : 'D');
      this.getCustomerName(type)
      let request = {
        callEndTime: endTime,
        callStartTime: startTime,
        callTypeSeq: this.customerData.callTypeSq || "",
        customerContactInd: this.talked,
        customerId: this.customerData.customerId,
        dealerCode: this.workshopCode,
        levelData: levelData,
        remark: this.creRemark || "",
        responseForNo: this.noResponce || "",
        serviceDueDate: serviceDueDate,
        userID: this.userId,
        vin: (this.cus360["VECHILE_INFO"].length > 1 &&  this.questionType != "PRS")? "" : vin,
        customerType: type,
        phoneNo: this.selectedNumber?this.selectedNumber:'',
        customerName: this.custNameForSave?this.custNameForSave:'',
        role:this.userRoles,
        roleId: this.roleId,
        jobCardNo: this.jobCardNo,
      };

      

      this.saveCallRecording(request);
    } else if (this.talked == "102" && this.noResponce == "") {
      this.showNoRespError = true;
    }
  }

  /**
  * Name: getLanguage
  * purpose: To get Languages
  */
  getLanguage() {
   // this.spinner = true;
    this.languageList = [];
    this.commonService.getLanguage().subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          res["responseData"].forEach(element => {
            this.languageList.push(element.languagePre)
            this.languageMap.set(element.languagePre, element.languageCode+"#"+element.languagePre);
          });
          //this.spinner = false;
        } else {
          //this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (error) => {
        this.toastr.error(error, "Error");
        //this.spinner = false;
      }
    );
  }

  onKey() : void {
    this.vehicleList = this.vehicleListCopy;
    this.vehicle = [];
   // this.selectedValue = this.selectWorkshop.controls.selectedDealer.value;
    this.selectedValue = this.selectedValue.toString();
    this.vehicle = this.vehicleList.filter(item =>
      item.toLowerCase().includes(this.selectedValue.toLowerCase())
    );
    if(this.vehicle.length > 0){
      this.closeInput();
    }
    this.vehicleList = [];
    this.vehicleList = this.vehicle;
  }

  closeInput() : void {
    if(this.vehicle.length == 0) {
     //this.selectedDealer = '';
     //this.selectWorkshop.controls["selectedDealer"].setValue("");
     this.selectedValue = "";
     this.vehicleList = this.vehicleListCopy;
    }
  }

  /**
 * Name: getCallList
 * purpose: To get customer call data
 */
  getCallList(): void {
    //this.spinner = true;
    this.commonService.callDetails(this.userId, this.customerID, 'PRS').subscribe(res => {
      if (res["responseCode"] == 0) {
        //this.spinner = false;
       
        this.callLists = new MatTableDataSource(res['responseData']);
        this.recentNumber = (res['responseData'].length && res['responseData'][0].custNo) ? res['responseData'][0].custNo.split('+91')[1] : '';
        this.sort.direction = '';
        this.callLists.sort = this.callLogsSort;
        this.callLists.paginator = this.paginator;
        this.callCount = res['responseData'].length;
      } else {
        //this.spinner = false;
      }
    }, err => {
      //this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
 * Name: getCallRecording
 * purpose: To get call recording and play
 */
  recordingUrl:string = ''
   
  getCallRecording(bucketName: string, fileName: string, id: string, source: string ,element:any): void {

    if (element.recordingUrl) {
        this.recordingUrl = element.recordingUrl;
      }else{
        this.recordingUrl = '';
      }
    this.spinner = true;
    this.onRecordingClose();
    this.commonService.downloadAudio(bucketName, fileName, source).subscribe(res => {
      this.spinner = false;
      var binary = res['body'];
      var blob = new Blob([binary], { type: 'audio/mp4' });
      this.audioSource.id = id;
      this.audioSource.url = URL.createObjectURL(blob);
      if (this.audioSource.url) {
        this.playRecording();
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  selectBlanket(value){
    if(value == 'D'&&this.roleId=="1"){
      this.diasableCreateComplain = false;
      this.disableSubmitButton = true ;
    }else{
      this.diasableCreateComplain = false;
      this.disableSubmitButton = false ;
    }
  }
  changeRating(formRating) {
    const formRatingInfo = this.questionForm.get(formRating);
    if (formRatingInfo.touched) {
      this.disableSubmitButton = false;
    }

    if (formRatingInfo.touched && this.roleId == "1") {
      let lessThanThree = false;
      for (const obj in this.questionForm.value) {
        let isRating=obj.toString()
        if (isRating.includes('rate')&&this.questionForm.value[obj] && this.questionForm.value[obj] <= 3) {
          lessThanThree = true;
        }
      }
      if (lessThanThree) {
        this.diasableCreateComplain = false;
        this.disableSubmitButton = true;
      } else {
        this.diasableCreateComplain = true;
      }
    } else if (formRatingInfo.touched && this.roleId == "12") {
      let allOneRating = false;
      this.diasableCreateComplain = false;
      for (const obj in this.questionForm.value) {
        let isRating=obj.toString()
        if (isRating.includes('rate')&&this.questionForm.value[obj] > 1) {
          allOneRating = true
        }
      }
      if (allOneRating) {
        this.disableSubmitButton = false;
      }
      else {
        this.disableSubmitButton = true;
      }
    }
  }


  /**
   * Name: playRecording
   * purpose: To play recoding
   */
  playRecording(): void {
    this.showPlayBtn = false;
    this.showRecordingDailog = true;
  }

  /**
   * Name: onRecordingClose
   * purpose: To close Recording dailog
   */
  onRecordingClose() {
    this.showPlayBtn = true;
    this.showRecordingDailog = false;
  }

  /**
   * Name: closeDailog
   * purpose: To close Dailog
   */
  closeDailog(): void {
    this.close.emit(null);
  }

  openComplaintDialog() {
    this.commonService.complaintCheck(this.jobCardNo, this.roleId, this.userId, this.callTypeCode, this.customerID, this.chassisNo).subscribe(res=>{
      if(res["responseData"] == "Complaint Does Not Exists") {
        openPrsComplaintDialog(this.dialog, this.customerData.dealerCode, this.customerID, this.vehicleDetails.chassisNo, this.vehicleDetails.registrationNo, this.jobCardNo, this.callTypeCode, this.roleId).subscribe(res=>{
          if(res.complaintId != '' && res.complaintId != null ) {
            this.complaintId = res.complaintId;
            this.complaintRemarks = res.complaintRemarks;
            this.disableSubmitButton = res.isSubmitted
          }
        });
      } else if(res["responseData"] == "Complaint Already Exists") {
        this.toastr.info("complaint Already Exists")
      }
    });
  }

  fetchBlockStatus() {
    this.commonService.fetchBlockStatus(this.customerID, 'prs').subscribe(res => {
      if (res["responseCode"] == 0) {
        this.blockStatus = res["responseData"].blockStatus;
        //this.spinner = false;
      } else {
        //this.spinner = false;
      }
    }, err => {
      //this.spinner = false;
      // this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }


  activeTabLabel: string = 'Owner'; 
  activeIndex:number = 0
  userInfo: any;


  selectedContactNumbers = {
    'Owner': null,
    'Fleet Manager': null,
    'Driver': null
  };

  onTabChange(event: MatTabChangeEvent) {
    this.activeTabLabel = event.tab.textLabel;
    this.activeIndex = event.index;
    this.updateActiveContactNo();
  }

 

  private updateActiveContactNo() {
    let contactList;
    
    if (this.activeIndex === 0) {
      contactList = this.contactInfoOwner;
    } else if (this.activeIndex === 1) {
      contactList = this.contactInfoFleet;
    } else if (this.activeIndex === 2) {
      contactList = this.contactInfoDriver;
    }
    
    console.log(this.activeIndex);
    console.log(contactList);
    if (contactList && contactList.length > 0) {
      this.selectedContactNumbers[this.activeTabLabel] = this.selectedContactNumbers[this.activeTabLabel] || contactList[0].contactNo;
    }
    
  }
  
  onRadioChange(contactNo: string, tabLabel: string) {
    this.selectedContactNumbers[tabLabel] = contactNo;
   
    
  }


  private callingToUser(){
    let customerPhone = this.selectedContactNumbers[this.activeTabLabel];
    if(customerPhone){
      this.makeCall(customerPhone)
    }else{
      this.spinner = false;
      this.toastr.error("Customer Phone number can't be Empty while placing the call")
    }
  }

  
  private makeCall(customerPhone:string) {
    const callParams = new CallParams(this.userInfo.contactNo, customerPhone);
    this.spinner = true
    this.commonService.createCallConnection_API(callParams).subscribe({
      next: (response) => {
        if(response.responseData.Uri) {
          localStorage.setItem("exotel_URI",response.responseData.Uri)
        } else{
          localStorage.setItem("exotel_URI",'')
        }
          
        if (response.responseCode==0) {
          this.toastr.success("Call is in progress")
        }else{
          this.toastr.error(response.responseData)
         
        }
        
      },
      error:(error)=>{
        this.spinner = false
        this.toastr.error("Something went wrong");
        this.showPrs360=false;
        
      },
      complete:()=>{
        this.spinner = false
      }
    });
  }


  private saveCallRecording(data:any){
    const URI = localStorage.getItem('exotel_URI')
    const CRE_ID = this.userInfo.userId 
    const CUSTOMER_CODE = this.customerData.customerId
    const SOURCE = "PRS";
    console.log("SAVE" , URI);
    if (URI)
      {
        this.spinner = true;
        const callRecordingParams = new SaveCallRecordingParams(CRE_ID,CUSTOMER_CODE,SOURCE,URI)
        this.commonService.saveCallRecording_API(callRecordingParams).subscribe({
          next:(response)=>{
            if (response.responseCode == 0) {
              this.toastr.success(response.message, 'Success')
              this.saveFormResponse(data);
            }
            else
            {
              this.toastr.error(response.message, 'Error');
              this.submitted = false;
              
            }
            
          }
          ,error:(error)=>{
            console.log(error);
            this.submitted = false;
            this.spinner = false;
          },
          complete:()=>{
            this.spinner = false;
            
            
          }
        })
      }else{
        this.saveFormResponse(data);
      }
  }

  private saveFormResponse(request: any){

    this.commonService.prsSaveData(request).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.toastr.info(res["message"], "Success");
          this.router.navigate(["prs-calling"])
          this.commonService.prsCustomerResponse = request;
          this.submitted = false;
          this.level1Form = undefined;
          this.level1info = [];
          this.level2Form = undefined;
          this.level2info = [];
          this.creRemark = null;
          this.showNoRespError = false;
          this.yesResponce = "";
          this.nsReason = "";
          if("101" == this.talked) {
            this.createLevel1Form(this.responseDropDownData&&this.responseDropDownData["Level1"]);
          }
          this.router.navigate(["prs-calling"]);
        } else {
          this.submitted = false;
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (error) => {
        this.submitted = false;
        this.toastr.error(error, "Error");
        this.spinner = false;
      }
    );
  }

  openConfirmation() {
    if (localStorage.getItem('countryCode')=='IND91') {
      this.dialogService.openConfirmDialog().subscribe(result => {
        if (result) {
          console.log(result);
          this.show360();    
        } else {
          console.log(result);
        }
      });
    }else{
      this.show360();
    }
   
  }
 
}